const orderSocketEventNamespace = "order";
const orderSocketEventTypeNames = [
    "cancelled",
    "commented",
    "confirmed",
    "created",
    "fulfilled",
    "fulfillment_reversed",
    "out_for_delivery",
    "pending_confirmation",
    "pending_delivery",
    "pending_payment_confirmation",
    "rejected",
    "refunded",
    "refunded_fulfilled",
    "bookable_time_change",
    "payrequest_fulfilled",
    "changed",
] as const;
type OrderSocketEventTypeName = (typeof orderSocketEventTypeNames)[number];

export { orderSocketEventNamespace, orderSocketEventTypeNames };
export type { OrderSocketEventTypeName };
